import React, { useEffect, useState } from "react";
import { ERCButton } from "components/button";
import Flying from "components/flying";
import { motion } from "framer-motion";
import Shopingcontent from "components/store/shopingcontent";
import { TiStar } from "react-icons/ti";
import { GameCard, TeacherStudentCard, StoreCard } from "components/store/card";
import CounsellorChatCard from "components/counsellorchatcard";
import Dropdown from "components/dropdown";
import { ERCText } from "components/text";
import Layout from "partials/layout";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "services";
import { setProduct } from "store/reducers/products";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "components/pagination/pagination";
import FaqDropdown from "pages/FooterPages/faq/FaqDropdwon";

const Store = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAllProduct();
  }, []);

  const fetchAllProduct = async () => {
    // setLoading(true);
    try {
      const data = await apiRequest({
        // method: 'get',
        url: "/product/all",
      });
      dispatch(setProduct(data?.data?.details?.rows));

      console.log("this is product details", data);
    } catch (error) {
      // console.error('Error fetching product details:', error);
    } finally {
      // setLoading(false);
    }
  };

  const products = useSelector((state) => state?.product?.data?.product);
  console?.log(products);

  const [currentPage, setCurrentPage] = useState(1);
  // Pagination
  const PageSize = 6;
  const firstPageIndex = (currentPage - 1) * PageSize;
  const lastPageIndex = firstPageIndex + PageSize;
  const currentTableData = products?.slice(firstPageIndex, lastPageIndex);

  console?.log(currentTableData);
  const totalPages = Math?.ceil(products?.length / PageSize);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  //   faqs
  const faqs = [
    {
      id: 1,
      question: "What is the Lagos State Education Resource Center?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 2,
      question: "Who can access the resources on this platform?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 3,
      question: "What type of resources are available on the platform?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 4,
      question:
        "Are the resources tailored to specific grade levels or subjects?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 5,
      question:
        "How can teachers integrate these resources into their lesson plans?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
  ];
  // status change
  const [productStatus, setProductStatus] = useState("All");
  const statuses = ["All", "Newest", "Trending", "Best Seller", "Featured"];
  const filteredProduct =
    productStatus === "All"
      ? currentTableData
      : currentTableData.filter(
          (product) => product.subCategory === productStatus
        );

  const handleViewDetails = (id) => {
    navigate(`/product-details/${id}`);
    window.scrollTo(0, 0);
  };

  return (
    <Layout>
      <div className="w-full">
        <div className="bg-[#49BBBD] pb-6  ">
          <div className="flex md:flex-row flex-col md:gap-[100px] gap-6 item-center justify-around md:py-12 py-6">
            <div className="flex flex-col pt-[60px] md:w-fit w-full px-6">
              <div className="flex gap-[10px] pl-[10px] rounded-[10px] bg-[#ffffff] w-[56%] h-[30%]">
                <Flying l="29%" t="200px">
                  <motion.div
                    animate={{ rotate: [45, 110] }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                      restSpeed: 0.5,
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="43"
                      viewBox="0 0 39 43"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.0489 40.1274C9.32492 39.0757 5.42609 38.5452 1.64397 38.0592C0.829355 37.9573 0.0730442 38.5259 0.0148577 39.3269C-0.101515 40.1286 0.480691 40.8617 1.23712 40.9636C4.90286 41.4314 8.68465 41.9321 12.234 42.9445C12.9904 43.1641 13.8054 42.7121 14.0381 41.9344C14.2709 41.1574 13.8053 40.3476 13.0489 40.1274Z"
                        fill="#FFD600"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.3375 25.2172C18.3443 19.0624 11.5947 13.6998 5.71783 7.37979C5.19415 6.78954 4.26317 6.75792 3.6813 7.30894C3.09944 7.86054 3.04148 8.78807 3.62334 9.37832C9.50018 15.7165 16.2498 21.0966 22.243 27.2696C22.8249 27.8458 23.7556 27.854 24.3375 27.2872C24.8612 26.721 24.9194 25.7934 24.3375 25.2172Z"
                        fill="#FFD600"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M35.5681 1.54341C35.7427 5.06616 35.9169 8.58891 36.0915 12.1123C36.0915 12.9192 36.7901 13.5422 37.6047 13.503C38.4193 13.4631 39.0008 12.7763 39.0008 11.9688C38.8262 8.44018 38.652 4.91216 38.4775 1.38413C38.4193 0.577224 37.7209 -0.0417174 36.9063 0.00219986C36.1499 0.0461172 35.5099 0.737085 35.5681 1.54341Z"
                        fill="#FFD600"
                      />
                    </svg>
                  </motion.div>
                </Flying>
                <img
                  className=" pt-[5px] h-[24px]"
                  src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721174405/ERC/shopping_cart_lain13.svg"
                  alt="cart"
                />
                <p className="font-manrope text-[#00296B] md:text-[14px] text-[10px] leading-[20px] font-semibold py-[5px]">
                  {" "}
                  WELCOME TO EDUCATIONAL RESOURCES STORE!
                </p>
              </div>

              <div className="flex flex-col pt-6">
                <p className="text-[#00296B] font-manrope md:text-[56px] text-[36px] md:leading-[72px] font-semibold">
                  <span className="text-[#FFD600]">Empower Learning: </span>
                  Explore <br></br> Our Vast Collection Today!
                </p>

                <p className="text-[#252525] font-manrope md:text-[28px] text-[16px] md:leading-[40px] font-semibold pt-[15px]">
                  Experience the future of education with our platform.{" "}
                  <br></br>Start your academic journey to success now.
                </p>
              </div>

              <div className="md:pt-12 pt-6">
                <ERCButton
                  weight={"700"}
                  g={"20px"}
                  size="16px"
                  p={"14px"}
                  color="#FFD600"
                  lHeight="24px"
                  width="184px"
                  showArrow
                >
                  Shop Now
                </ERCButton>
              </div>
            </div>
            {/* img div */}
            <div className="px-6">
              <img
                className="md:w-[500px] w-full h-[400px] mt-[60px]"
                src={
                  "https://res.cloudinary.com/dmrtylvtc/image/upload/v1725010716/ERC/book_upu3k7.svg"
                }
                alt="book"
              />
            </div>
          </div>
          <div className="grid md:grid-cols-4 items-center grid-cols-1 gap-[30px] border bg-[#ffffff] w-full md:px-24 px-6 py-6">
            <Shopingcontent
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721144158/ERC/Div_under__user-back_xgj8kv.svg"
              }
              textContent={"Flexible Payment"}
              smallContent={"Pay via Multiple Platforms"}
            />
            <Shopingcontent
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721144158/ERC/Div_under__user-back_1_pfiyz4.svg"
              }
              textContent={"Online Support"}
              smallContent={"24/7 Customer Support "}
            />
            <Shopingcontent
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721144158/ERC/Div_under__user-back_2_fvvky7.svg"
              }
              textContent={"Easy Shipping"}
              smallContent={"Pick Up Items with Ease"}
            />
            <Shopingcontent
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721144158/ERC/Div_under__user-back_3_uzmsuf.svg"
              }
              textContent={"Quality"}
              smallContent={"Tested and Trusted platform"}
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 md:px-24 px-6 grid-cols-1 gap-[50px] py-12">
          <GameCard
            goodsTitle={"Game Store"}
            goodsDirection={"shop Now"}
            img={
              "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721814223/ERC/Paste_image_rnwezs.jpg"
            }
            height="580px"
          />
          <div className="grid grid-cols-1 gap-[10px]">
            <TeacherStudentCard
              teacherStudentGoodsTitle={"Teachers's Store"}
              shopNow={"shop Now"}
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721812943/ERC/Paste_image_lej2lm.jpg"
              }
              height="320px"
            />
            <TeacherStudentCard
              teacherStudentGoodsTitle={"Students' Store"}
              shopNow={"shop Now"}
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1721812943/ERC/Paste_image_1_vufssr.svg"
              }
            />
          </div>
        </div>

        <div className="text-[#000] md:px-24 p-6 font-manrope text-[40px] leading-[48px] font-semibold">
  <h2>Featured</h2>
</div>

{/* Scrollable container on small screens */}
<div className="w-full md:px-24 px-6">
  <div className="flex overflow-x-auto scrollbar-hide gap-6 md:grid md:grid-cols-2 lg:grid-cols-4 justify-start">
    {products?.length > 0 ? (
      products?.slice(0, 4).map((product) => (
        <StoreCard
          key={product?.id}
          title={product?.name}
          slashPrice={`NGN ${product?.price}`}
          discount={`-${product.discount}%`}
          amount={`NGN ${
            product.price - product.price * (product.discount / 100)
          }`}
          number={"1000"}
          img={product.productImage[0]}
          viewDetails={"View Details"}
          onClick={() => handleViewDetails(product?.id)}
        />
      ))
    ) : (
      <p className="flex justify-center items-center text-2xl">
        No products available
      </p>
    )}
  </div>
</div>

        <div className="pt-[150px] ">
          <div className="text-center">
            <h2 className="text-[#000] font-manrope text-[40px] leading-[48px] font-semibold">
              {" "}
              Our Products
            </h2>
          </div>
          <div className="flex item-center justify-center gap-[20px] pt-[20px]">
            <div className="flex overflow-x-auto scrollbar-hide gap-4 md:px-[100px] scroll-smooth px-6">
              {statuses.map((product) => (
                <button
                  key={product}
                  onClick={() => setProductStatus(product)}
                  className={`whitespace-nowrap md:text-[16px] transition-all hover:bg-secondary font-ManropeSemibold md:leading-[24px] rounded-sm px-4 py-2 ${
                    productStatus === product
                      ? "bg-secondary text-white"
                      : "text-black border-[1px] border-secondary"
                  }`}
                >
                  {product}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-10">
          <div className="w-full flex flex-col justify-center items-center py-12 md:px-24 px-6 ">
            <div className="grid grid-cols-1  w-full gap-12 md:grid-cols-3 lg:grid-cols-4 ">
              {products?.length > 0 ? (
                //    currentTableData
                filteredProduct?.map((product) => (
                  <StoreCard
                    key={product?.id}
                    title={product?.name}
                    slashPrice={`NGN ${product?.price}`}
                    discount={`-${product?.discount}%`}
                    amount={`NGN ${
                      product?.price -
                      product?.price * (product?.discount / 100)
                    }`}
                    number={"1000"}
                    img={product?.productImage[0]}
                    viewDetails={"View Details"}
                    // onClick={handleViewDetails(product.id)}
                    onClick={() => handleViewDetails(product?.id)}
                  />
                ))
              ) : (
                <p className="flex justify-center items-center text-2xl">
                  No products available
                </p>
              )}
            </div>
          </div>
          <div className="w-full px-10 mt-10">
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        <section className="flex item-center justify-center py-12 bg-[#F6F6F3]">
          <CounsellorChatCard />
        </section>

        <section className="md:p-24 p-6 flex justify-center items-center flex-col gap-12  text-[#1D2026]">
          <ERCText size="40px" lHeight="48px" color="#00296B" weight="700">
            Frequently Asked Questions
          </ERCText>
          <div className="md:w-2/4 w-full  flex flex-col gap-6">
            {faqs.map((data) => (
              <FaqDropdown
                key={data.id}
                smallText={data.answer}
                header={data.question}
              />
            ))}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Store;
